import type { Draft } from 'immer';
import type { GraphState } from '../GraphState';

export const clearSharedView = (draft: Draft<GraphState>): void => {
  if (draft.sharedViewId) {
    draft.sharedViewId = null;
    // clear loaded view to avoid overriding it via save button
    draft.loadViewDialog.loadedView = null;
  }
};
